import { Navigate } from "react-router-dom";
import { Spin } from "antd";
import { usePermissions } from "../custom_hooks/permission/permission_hook";

export interface ProtectedRouteProps {
  permission: any;
  children: any;
}

const ProtectedRoute = ({ permission, children }: ProtectedRouteProps) => {
  const { hasPermission, loaded } = usePermissions();

  const permissionList: string[] = Array.isArray(permission) ? permission : [permission];

  if (!loaded) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ height: "100vh" }}>
        <Spin size="large" />
      </div>
    );
  }

  if (!permissionList.some((p) => hasPermission(p))) {
    return <Navigate to={"/user-profile"} />;
  }
  return children;
};

export default ProtectedRoute;
